'use client';
import { useSignUpController } from './use-sign-up-controller';
import type { SignUpFormProps } from './use-sign-up-state';
import { SignUpView } from './sign-up-view';
export function SignUpForm(props: SignUpFormProps) {
  const model = useSignUpController(props);
  return <SignUpView {...model} />;
}
